import { useState } from "react";

const faqs = [
  {
    question: "Combien de temps faut-il attendre pour une réparation à Sélestat ?",
    answer:
      "Sélestat se trouve au sud du Bas-Rhin, à environ 45 minutes de notre atelier. Pour les urgences, nous intervenons en 24 heures. Pour les réparations programmées, comptez 24 à 48 heures. Le déplacement est gratuit dans tout le département, et le technicien vous appelle avant de partir pour vous donner un créneau précis.",
  },
  {
    question: "Les fenêtres des maisons à colombages de Sélestat sont-elles prises en charge ?",
    answer:
      "Oui, et c'est un de nos domaines de prédilection. Le centre historique de Sélestat regorge de maisons à colombages avec des fenêtres en bois ancien. Nos techniciens connaissent les spécificités de ces menuiseries et disposent des pièces adaptées. Nous réparons aussi les fenêtres modernes des quartiers périphériques : PVC, aluminium, toutes marques. Chaque pièce remplacée est garantie 10 ans.",
  },
  {
    question: "Quelles marques de quincaillerie réparez-vous ?",
    answer:
      "Nous réparons toutes les marques de quincaillerie : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi, Cadiou. Nos techniciens identifient la marque exacte sur place et arrivent avec un stock de pièces courantes. Si la pièce est rare, nous la commandons et revenons en 48 heures maximum. Le diagnostic est gratuit, le devis est détaillé, et vous ne payez que l'intervention réalisée.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Sélestat
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-white rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}